import { useState } from 'react';

import { Modal } from '@/components';
import { CaregiverCallConfirmationType } from '@/shared/call/CaregiverCallConfirmationType';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { CaregiverCallConfirmationManager } from './CaregiverCallConfirmationManager';
import { ConfirmEndConsultationAfterCallModal } from './ConfirmEndConsultationAfterCallModal';
import { PhoneCallCompletedModal } from './PhoneCallCompletedModal';

type CaregiverCallConfirmationModalProps = {
    consultationUid: string;
    confirmationType: CaregiverCallConfirmationType;
    onClose: (isAutoClosed?: boolean) => void;
    onConsultationEndedAfterCall?: (topic?: string | null) => void;
};

type Step = 'main' | 'phoneCallCompleted' | 'confirmEndConsultation';

export const CaregiverCallConfirmationModal = ({
    consultationUid,
    confirmationType,
    onClose,
    onConsultationEndedAfterCall,
}: CaregiverCallConfirmationModalProps) => {
    const [step, setStep] = useState<Step>('main');

    if (step === 'phoneCallCompleted') {
        return (
            <PhoneCallCompletedModal
                onClose={() => onClose(false)}
                onKeepConsultation={() => onClose(true)}
                onRequestEndConsultation={() =>
                    setStep('confirmEndConsultation')
                }
            />
        );
    }

    if (step === 'confirmEndConsultation') {
        return (
            <ConfirmEndConsultationAfterCallModal
                consultationUid={consultationUid}
                onClose={() => onClose(false)}
                onCancel={() => setStep('phoneCallCompleted')}
                onEnded={(topic) => {
                    onConsultationEndedAfterCall?.(topic);
                    onClose(true);
                }}
            />
        );
    }

    return (
        <Modal
            title={getTitle(confirmationType)}
            onClose={() => onClose(false)}
            className="max-w-[487px]"
        >
            <CaregiverCallConfirmationManager
                consultationUid={consultationUid}
                confirmationType={confirmationType}
                onClose={onClose}
                onPhoneCallCompleted={() => setStep('phoneCallCompleted')}
            />
        </Modal>
    );
};

const getTitle = (confirmationType: CaregiverCallConfirmationType) => {
    return confirmationType === CaregiverCallConfirmationType.video
        ? R.VideoCallTitle
        : R.PhoneCallTitle;
};
